import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/globals.css'
import { App } from './App'
import { initFirebase } from './features/auth/firebase'
import { NotConfiguredPage } from './routes/not-configured'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('#root element not found in index.html')
}

const root = createRoot(rootEl)
const init = initFirebase()

if (!init.ok) {
  root.render(
    <StrictMode>
      <NotConfiguredPage missing={init.missing} />
    </StrictMode>,
  )
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
